import React from 'react';
import _ from 'lodash';
import SchemaForm from 'app/components/general/SchemaForm';
import SectionGroup from 'app/components/general/SectionGroup';
import HeaderThin from 'app/components/layout/HeaderThin';

import { sports } from 'app/utils/static/sports';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as teamActions from 'app/ducks/teams/actions';
import * as teamSelectors from 'app/ducks/teams/selectors';
import * as seasonActions from 'app/ducks/seasons/actions';

import * as seasonSelectors from 'app/ducks/seasons/selectors';

const uiSchema = {
  name: { classNames: 'col' },
  sport: { classNames: 'col col-12', 'ui:field': 'select' },
  season: { 'ui:field': 'select', classNames: 'col col-12' },
};

const selector = (state) => ({
  teams: teamSelectors.getTeams(state),
  seasons: seasonSelectors.getSeasons(state),
  errors: { ...state.teams.backendErrors },
});

const actionCreators = _.merge(teamActions, seasonActions);

interface ICreateTeamProps {
  appReady: boolean;
  actions: any;
  seasons: any;
  teams: any;
  errors: any;
  backendErrors: any;
  match: any;
  teamId: string;
  afterSubmit: Function;
}

export interface ICreateTeamState {
  originalFormData: any;
  formData: any;
  changed: boolean;
  saved: boolean;
  reset: boolean;
  errors: any;
}

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class CreateTeam extends React.Component<
ICreateTeamProps,
ICreateTeamState
> {
  static defaultProps: ICreateTeamProps = {
    appReady: false,
    actions: undefined,
    match: undefined,
    seasons: undefined,
    teams: undefined,
    backendErrors: undefined,
    errors: undefined,
    teamId: undefined,
    afterSubmit: undefined,
  };

  state: ICreateTeamState = {
    originalFormData: {},
    formData: {},
    changed: false,
    saved: false,
    reset: false,
    errors: {},
  };

  // componentDidUpdate = (prevProps): void => {
  //   if (
  //     !this.props.teams.hasSaved
  //     && prevProps.teams.currentTeam
  //     !== this.props.teams.currentTeam
  //     && !_.isEmpty(this.props.teams.currentTeam.id)
  //   ) {
  //     this.props.actions.getTeam(
  //       this.props.teams.currentTeamId,
  //     );
  //   }
  // }

  componentDidMount() {
    this.props.actions.getAllSeasons();
  }

  static getDerivedStateFromProps(nextProps, prevState): any {
    if (!prevState.reset && !prevState.changed) {
      // const formData = {
      //   name: nextProps.teams.currentFormTeam.name || '',
      //   sport: nextProps.teams.currentFormTeam.sport || undefined,
      // };

      return {
        ...prevState,
        errors: nextProps.teams.errors,
      };
    }
    // if (nextProps.hasSaved) {
    //   return {
    //     originalFormData: {},
    //     formData: {},
    //     changed: false,
    //     saved: false,
    //     errors: {},
    //   };
    // }
    return null;
  }

  isValid = (): boolean => _.isEmpty(this.state.errors) && this.state.changed;

  handleChange = (e): void => {
    const changed = this.state.originalFormData !== e.formData;
    this.setState(() => ({
      formData: e.formData,
      errors: [],
      reset: false,
      changed,
    }));
  };

  handleError = (errors): void => {
    this.setState({ errors });
  }

  handleSubmit = (data, e): void => {
    if (this.isValid()) {
      let season = {};
      let seasonName;
      if (this.state.formData.season?.__isNew__) {
        seasonName = this.state.formData.season.value;
      } else {
        season = {
          id: this.state.formData.season.id,
        };
      }
      this.props.actions.createTeam({
        name: this.state.formData.name,
        sport: this.state.formData.sport.id,
        seasonName,
        season,
      });
      if (e.nativeEvent?.submitter?.name === 'submitAddAnother') {
        this.setState({
          originalFormData: {},
          formData: {},
          reset: true,
          changed: false,
          saved: false,
          errors: {},
        });
      } else {
        this.props.afterSubmit(e);
      }
    }
    this.setState({ changed: false });
  };

  render(): React.ReactNode {
    const seasons = this.props.seasons.seasonsByIdInSelectFormat;

    const formSchema = {
      required: ['name', 'sport'],
      properties: {
        name: {
          type: 'string',
          title: 'Team Name',
        },
        sport: {
          type: 'object',
          title: 'Sport',
          options: sports,
          inputType: 'select',
        },
        season: {
          type: 'object',
          title: 'Season',
          inputType: 'select',
          options: seasons,
          createable: true,
          clearable: true,
        },
      },
    };

    return (
      <SchemaForm
        uiSchema={uiSchema}
        schema={formSchema}
        handleChange={this.handleChange}
        handleError={this.handleError}
        handleSubmit={this.handleSubmit}
        formData={this.state.formData}
        errors={this.props.errors}
        liveValidate={false}
        isValid={this.isValid()}
        isLoading={this.props.teams.isSaving}
        hasSaved={this.props.teams.hasSaved}
        hasFailed={this.props.teams.hasFailed}
        originalFormData={this.state.originalFormData}
      />
    );
  }
}
